





















































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/indent */
import Vue from 'vue'
import ActiveModInset from '../components/_ActiveModInset.vue'
import AmmoCaseInset from '../../mech_loadout/components/mount/weapon/_AmmoCaseInset.vue'
import PilotTalent from '@/classes/pilot/PilotTalent'
import { ActivationType, Damage, DiceRoller, Range, WeaponSize, WeaponType } from '@/class'
import CbCard from '../../mech_loadout/components/mount/_CbCard.vue'

export default Vue.extend({
  name: 'weapon-attack',
  components: { AmmoCaseInset, ActiveModInset, CbCard },
  props: {
    item: {
      type: Object,
      required: true,
    },
    mech: {
      type: Object,
      required: true,
    },
    mount: {
      type: Object,
      required: false,
      default: null,
    },
    aux: { type: Boolean },
    improv: { type: Boolean },
    barrage: { type: Boolean },
    overwatch: { type: Boolean },
  },
  data: () => ({
    tab: 0,
    ammoCost: 0,
    overkillRolls: [],
    autoOverkillString: '',
    ammoDamage: '',
    accuracy: 0,
    difficulty: 0,
    attackRoll: null,
    rollResultString: null,
    rollAccuracyResults: [],
    attackQuick: false,
    attackFree: false,
    hit: false,
    missed: false,
    damageRolls: [],
    damageResultString: null,
    bonusDamage: null,
    kill: false,
    confirmed: false,
  }),
  computed: {
    state() {
      return this.mech.Pilot.State
    },
    noDamageItem() {
      return !this.item.Damage.length
    },
    missText() {
      if (this.reliable) return 'Glancing hit'
      switch (this.item.WeaponType) {
        case 'Rifle':
        case 'Cannon':
          return 'Shot wide'
        default:
          return 'No effect'
      }
    },
    overkill() {
      return this.item.Tags.some(x => x.IsOverkill)
    },
    overkillHeat() {
      return this.overkillRolls.length
    },
    crit() {
      return this.attackRoll && this.attackRoll >= 20
    },
    attacked() {
      return this.attackQuick || this.attackFree
    },
    hardpoints() {
      if (!this.mount) return false
      if (this.item.NoCoreBonus) return false
      return (
        this.mount.Bonuses &&
        this.mount.Bonuses.find(x => x.ID === 'cb_auto_stabilizing_hardpoints')
      )
    },
    overpower() {
      if (!this.mount) return false
      if (this.item.NoCoreBonus) return false
      return this.mount.Bonuses && this.mount.Bonuses.find(x => x.ID === 'cb_overpower_caliber')
    },
    armoryLevel() {
      if (
        this.improv ||
        this.item.Size !== WeaponSize.Main ||
        this.item.WeaponType === WeaponType.Melee
      )
        return 0
      const tal = this.mech.Pilot.Talents.find(
        (x: PilotTalent) => x.Talent.ID === 't_walking_armory'
      )
      if (!tal) return 0
      return tal.Rank
    },
    getRange() {
      if (!this.item) return []
      return Range.CalculateRange(this.item, this.mech)
    },
    getDamage() {
      if (!this.item) return []
      return Damage.CalculateDamage(this.item, this.mech)
    },
    isSmart() {
      if (this.item.Tags.some(x => x.IsSmart)) return true
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.IsSmart)) return true
      return false
    },
    reliable() {
      const r = this.item.Tags.find(x => x.ID === 'tg_reliable')
      return r ? r.Value : 0
    },
    minAccuracy() {
      let bonus = 0
      if (this.item.Tags.some(x => x.ID === 'tg_accurate')) bonus += 1
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.ID === 'tg_accurate')) bonus += 1
      if (this.hardpoints) bonus += 1
      return bonus
    },
    minDifficulty() {
      if (this.item.Tags.some(x => x.ID === 'tg_inaccurate')) return 1
      if (this.item.Mod && this.item.Mod.AddedTags.some(x => x.ID === 'tg_inaccurate')) return 1
      return 0
    },
    attackRollString() {
      let str = `<div class="text-center"><div class='overline my-n2 subtle--text'>1d20 + Attack Bonus + (Accuracy - Difficulty)</div>`
      str += `<div class='heading h3 text--text'>1d20 + ${this.mech.AttackBonus}`
      const totalAcc = this.accuracy - this.difficulty
      if (totalAcc) {
        str += ` ${totalAcc > 0 ? '+' : '-'} ${Math.abs(totalAcc)}d6`
        if (Math.abs(totalAcc) > 1)
          str += ' <span class="caption subtle--text">(take highest)</span>'
      }
      str += '</div></div>'
      return str
    },
    attackRollTooltip() {
      let str = this.attackRollString
      if (this.rollResultString) {
        str += `<div class="overline my-n2">Last Roll:</div><div class="caption ml-3">${this.rollResultString}`
        if (this.rollAccuracyResults.length)
          str += ` <span class="subtle--text">[${this.rollAccuracyResults.join(', ')}]</span>`
        str += '</div>'
      } else str += '<div><br></div>'
      return str
    },
    damageRollString() {
      let str = '<div class="heading h3 text--text">'
      this.getDamage.forEach((d, i) => {
        str += `${i > 0 ? ' + ' : ''}${d.Value}`
      })
      str += '</div>'
      return str
    },
    damageRollTooltip() {
      let str = this.damageRollString
      str += `<div class="overline my-n2">Last Roll:</div><div class="caption ml-3">${this
        .damageResultString || '--'}</div>`
      return str
    },
    summedDamage() {
      let dmg = 0
      this.damageRolls.forEach(v => {
        dmg += parseInt(v)
      })
      if (this.bonusDamage) dmg += parseInt(this.bonusDamage)
      return dmg
    },
    finalDamage() {
      return this.reliable > this.summedDamage ? this.reliable : this.summedDamage
    },
  },
  watch: {
    tab(newval: number) {
      this.item.SetProfileSelection(newval, true)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    setAmmoCost(cost) {
      this.ammoCost = cost
    },
    setAmmoDamage(damage) {
      this.ammoDamage = damage
    },
    rollAttack(): void {
      const roll = DiceRoller.rollToHit(this.mech.AttackBonus, this.accuracy, this.difficulty)
      this.rollResultString = `${roll.rawDieRoll} + ${roll.staticBonus}`
      if (roll.accuracyResult) {
        this.rollResultString += ` ${roll.accuracyResult > 0 ? '+' : '-'} ${Math.abs(
          roll.accuracyResult
        )}`
      }
      this.rollAccuracyResults = roll.rawAccuracyRolls
      this.attackRoll = roll.total
    },
    rollDamage(): void {
      this.damageResultString = ''
      this.getDamage.forEach((d, i) => {
        const result = DiceRoller.rollDamage(d.Value, this.crit, this.overkill)
        if (this.overkill) {
          this.overkillRolls = Array(result.overkillRerolls).fill(1)
          this.autoOverkillString = `<br> COMP/CON rolled: ${'[1]'.repeat(
            result.overkillRerolls
          )}. Final Overkill re-roll: [${result.rawDieRolls.join('][')}]<br><b>+${
            result.overkillRerolls
          } Overkill Heat</b>`
        }
        if (this.damageRolls[i]) {
          Vue.set(this.damageRolls, i, result.total)
        } else {
          this.damageRolls.push(result.total)
        }
        this.damageResultString += `<b>${result.total}</b> ${
          d.Type
        } Damage <span class="subtle--text">[${result.rawDieRolls.join(', ')}]</span>`
      })
    },
    confirm(): void {
      this.confirmed = true
      const actionObj = {
        accuracy: this.accuracy - this.difficulty,
        hit: this.hit,
        damage: this.summedDamage,
        kill: this.kill,
        activation: this.improv
          ? ActivationType.Full
          : this.attackQuick
          ? ActivationType.Quick
          : ActivationType.Free,
      }
      let cost = 1
      cost = this.item.Cost
      this.item.Use(cost, actionObj.activation === ActivationType.Free)
      if (this.ammoCost) this.state.SpendAmmoCost(this.ammoCost)
      this.mech.CurrentHeat += this.item.ProfileHeatCost
      this.mech.CurrentHeat += this.overkillHeat
      this.mech.Pilot.State.LogAttackAction('ATTACK', this.item.Name, this.summedDamage, this.kill)
      this.$emit('confirm', actionObj.activation === ActivationType.Free)
    },
    reset() {
      this.mech.Pilot.State.UndoLogAttackAction(
        'ATTACK',
        this.item.Name,
        this.summedDamage,
        this.kill
      )
      if (this.ammoCost) this.state.RefundAmmoCost(this.ammoCost)
      this.init()
      this.$emit('reset')
    },
    init(): void {
      this.ammoCost = 0
      this.ammoDamage = ''
      this.accuracy = this.minAccuracy
      this.difficulty = this.minDifficulty
      this.attackRoll = null
      this.rollResultString = null
      this.rollAccuracyResults = []
      this.attackQuick = false
      this.attackFree = false
      this.hit = false
      this.missed = false
      this.damageRolls = []
      this.damageResultString = null
      this.bonusDamage = null
      this.kill = false
      this.confirmed = false
    },
  },
})
